import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class PurchaseRequiredDialogService {
    private _purchaseRequiredDialogSource = new BehaviorSubject<any>({});
    purchaseRequiredDialogSource$ = this._purchaseRequiredDialogSource.asObservable();

    setState(state) {
        this._purchaseRequiredDialogSource.next(state);
    }
}
